import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

const initialState = {
  fullscreen: false,
};

export const videoPlayerReducer = createReducer(initialState, {
  [types.VIDEO_PLAYER_ORENTATION](state, action) {
    return {
      fullscreen: action.response,
    };
  },
});
